import { memo, type FC } from 'react';
import { useTheme } from 'styled-components';

import Icons from '../../../../Elements/Icons/index.ts';
import { InfoTooltipIcon } from '../../../../Feedback/InfoTooltipIcon/index.tsx';
import { useTableContext } from '../../context.tsx';
import { HeadWrapper } from './styled.ts';
import type { HeadProps } from './types.ts';

export const Head: FC<HeadProps> = memo(function Head({
  children,
  className,
  align,
  contentType,
  order,
  handleChangeOrder,
  tooltip,
  dataTestId,
}) {
  const { colors } = useTheme();
  const { compact } = useTableContext();

  return (
    <HeadWrapper
      className={className}
      $align={align}
      $contentType={contentType}
      $order={order}
      $sortable={!!handleChangeOrder}
      $compact={compact}
      onClick={handleChangeOrder}
      role='columnheader'
      data-testid={dataTestId}>
      {handleChangeOrder && (
        <Icons.Arrow size={16} color={order ? colors.main : colors.black_1} align={order === 'ASC' ? 'top' : 'bottom'} />
      )}
      {children}
      {tooltip && <InfoTooltipIcon tooltip={tooltip} />}
    </HeadWrapper>
  );
});
